import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="grid-two-column">
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Where artisanal craftsmanship meets timeless elegance
            </h1>
            <p className="body-large" style={{ marginBottom: '40px', color: 'var(--text-secondary)' }}>
              Each pair of SOLENNE shoes is meticulously handcrafted by Italian artisans using the finest materials. Experience luxury that transcends trends.
            </p>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <button className="btn-primary">
                Explore Collection
                <ArrowRight size={16} style={{ marginLeft: '8px' }} />
              </button>
              <button className="btn-secondary">
                Our Story
              </button>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ 
              width: '100%', 
              height: '500px', 
              background: 'var(--bg-secondary)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-light)'
            }}>
              <span className="body-regular">Hero Image Placeholder</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
